export default __webpack_public_path__ + "static/media/student-link.af0209d5.svg";